<div fxLayout="column" class="cats-height" fxLayoutAlign="center center">
  <h1>My Cats</h1>

  <br>
  <form [formGroup]="filterForm">
    <mat-card style="max-width: 1170px">
      <mat-card-content >
        <mat-form-field class="filter-rarity">
          <mat-label>Rarity</mat-label>
          <mat-select placeholder="Rarity" multiple  formControlName="rarity">
            <mat-option *ngFor="let rarity of rarityList; let i =index" [value]="rarity">
            {{rarity}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="filter-mining">
          <mat-label>Mining</mat-label>
          <mat-select placeholder="Mining" formControlName="mining">
            <mat-option>All</mat-option>
            <mat-option value="yes">Yes</mat-option>
            <mat-option value="no">No</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>
  </form>


  <div class="cats-loader" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
    <p>{{ loaderMessage }}</p>
  </div>

  <div fxLayout.gt-xs="row wrap" fxLayout.xs="column" fxLayoutAlign="center center">
    <div *ngFor="let item of myItems">
      <app-page-presentation-card [item]="item" itemId={{item.catId}} amountMinted={{item.amountMinted}} [showMenu]="true"></app-page-presentation-card>
    </div>
  </div>

  <div *ngIf="collectingInProgress" fxLayout.gt-xs="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" style="position: fixed; bottom:0px; width:100%; height: 5em; background-color: white; border-top: #555 solid 1px;">
    Selected&nbsp;<b>{{selectedCats}}</b>&nbsp;cats. Total amount:&nbsp;<b>{{catcToBeCollected | number : '1.2-2'}}</b>&nbsp;CATC
    <button mat-raised-button color="primary" style="margin: 0.2em" (click)="completeCollecting()">Collect</button>
    <button mat-raised-button style="margin: 0.2em" (click)="cancelCheckboxes()">Cancel</button>
  </div>
  <div *ngIf="transferingInProgress" fxLayout.gt-xs="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" style="position: fixed; bottom:0px; width:100%; height: 5em; background-color: white; border-top: #555 solid 1px;">
    Selected&nbsp;<b>{{selectedCats}}</b>&nbsp;cats.
    <button mat-raised-button color="primary" style="margin: 0.2em" (click)="completeTransfer()">Transfer</button>
    <button mat-raised-button style="margin: 0.2em" (click)="cancelCheckboxes()">Cancel</button>
  </div>
</div>
